// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Formality from "../../../../../../node_modules/re-formality/src/Formality.bs.js";
import * as Caml_option from "../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Formality__ReactUpdate from "../../../../../../node_modules/re-formality/src/Formality__ReactUpdate.bs.js";

var validators_useOfPorter = {
  strategy: /* OnSubmit */4,
  validate: (function (param, param$1) {
      var useOfPorter = param.useOfPorter;
      if (useOfPorter !== undefined) {
        return {
                TAG: /* Ok */0,
                _0: useOfPorter.value
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: "Please select one option"
              };
      }
    })
};

var validators_city = {
  strategy: /* OnSubmit */4,
  validate: (function (param, param$1) {
      var city = param.city;
      if (city !== undefined) {
        return {
                TAG: /* Ok */0,
                _0: city.value
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: "Please select one option"
              };
      }
    })
};

var validators_lastName = {
  strategy: /* OnSubmit */4,
  validate: (function (param, param$1) {
      var lastName = param.lastName;
      var match = lastName.length;
      if (match !== 0) {
        return {
                TAG: /* Ok */0,
                _0: lastName
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: "Can't be empty"
              };
      }
    })
};

var validators_firstName = {
  strategy: /* OnSubmit */4,
  validate: (function (param, param$1) {
      var firstName = param.firstName;
      var match = firstName.length;
      if (match !== 0) {
        return {
                TAG: /* Ok */0,
                _0: firstName
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: "Can't be empty"
              };
      }
    })
};

var validators = {
  useOfPorter: validators_useOfPorter,
  city: validators_city,
  lastName: validators_lastName,
  firstName: validators_firstName
};

function initialFieldsStatuses(_input) {
  return {
          useOfPorter: /* Pristine */0,
          city: /* Pristine */0,
          lastName: /* Pristine */0,
          firstName: /* Pristine */0
        };
}

function initialState(input) {
  return {
          input: input,
          fieldsStatuses: {
            useOfPorter: /* Pristine */0,
            city: /* Pristine */0,
            lastName: /* Pristine */0,
            firstName: /* Pristine */0
          },
          collectionsStatuses: undefined,
          formStatus: /* Editing */0,
          submissionStatus: /* NeverSubmitted */0
        };
}

function validateForm(input, validators, fieldsStatuses, metadata) {
  var match = fieldsStatuses.useOfPorter;
  var match_0 = match ? match._0 : Curry._2(validators.useOfPorter.validate, input, metadata);
  var match$1 = fieldsStatuses.city;
  var match_0$1 = match$1 ? match$1._0 : Curry._2(validators.city.validate, input, metadata);
  var match$2 = fieldsStatuses.lastName;
  var match_0$2 = match$2 ? match$2._0 : Curry._2(validators.lastName.validate, input, metadata);
  var match$3 = fieldsStatuses.firstName;
  var match_0$3 = match$3 ? match$3._0 : Curry._2(validators.firstName.validate, input, metadata);
  var useOfPorterResult = match_0;
  var useOfPorterResult$1;
  if (useOfPorterResult.TAG === /* Ok */0) {
    var cityResult = match_0$1;
    if (cityResult.TAG === /* Ok */0) {
      var lastNameResult = match_0$2;
      if (lastNameResult.TAG === /* Ok */0) {
        var firstNameResult = match_0$3;
        if (firstNameResult.TAG === /* Ok */0) {
          return {
                  TAG: /* Valid */0,
                  output: {
                    firstName: firstNameResult._0,
                    lastName: lastNameResult._0,
                    city: cityResult._0,
                    useOfPorter: useOfPorterResult._0
                  },
                  fieldsStatuses: {
                    useOfPorter: /* Dirty */{
                      _0: useOfPorterResult,
                      _1: /* Shown */0
                    },
                    city: /* Dirty */{
                      _0: cityResult,
                      _1: /* Shown */0
                    },
                    lastName: /* Dirty */{
                      _0: lastNameResult,
                      _1: /* Shown */0
                    },
                    firstName: /* Dirty */{
                      _0: firstNameResult,
                      _1: /* Shown */0
                    }
                  },
                  collectionsStatuses: undefined
                };
        }
        useOfPorterResult$1 = useOfPorterResult;
      } else {
        useOfPorterResult$1 = useOfPorterResult;
      }
    } else {
      useOfPorterResult$1 = useOfPorterResult;
    }
  } else {
    useOfPorterResult$1 = useOfPorterResult;
  }
  return {
          TAG: /* Invalid */1,
          fieldsStatuses: {
            useOfPorter: /* Dirty */{
              _0: useOfPorterResult$1,
              _1: /* Shown */0
            },
            city: /* Dirty */{
              _0: match_0$1,
              _1: /* Shown */0
            },
            lastName: /* Dirty */{
              _0: match_0$2,
              _1: /* Shown */0
            },
            firstName: /* Dirty */{
              _0: match_0$3,
              _1: /* Shown */0
            }
          },
          collectionsStatuses: undefined
        };
}

function useForm(initialInput, metadata, onSubmit) {
  var memoizedInitialState = React.useMemo((function () {
          return initialState(initialInput);
        }), [initialInput]);
  var match = Formality__ReactUpdate.useReducer(memoizedInitialState, (function (state, action) {
          if (typeof action === "number") {
            switch (action) {
              case /* BlurUseOfPorterField */0 :
                  var result = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.useOfPorter, validators_useOfPorter, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  useOfPorter: status,
                                  city: init.city,
                                  lastName: init.lastName,
                                  firstName: init.firstName
                                };
                        }));
                  if (result !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurCityField */1 :
                  var result$1 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.city, validators_city, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  useOfPorter: init.useOfPorter,
                                  city: status,
                                  lastName: init.lastName,
                                  firstName: init.firstName
                                };
                        }));
                  if (result$1 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$1,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurLastNameField */2 :
                  var result$2 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.lastName, validators_lastName, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  useOfPorter: init.useOfPorter,
                                  city: init.city,
                                  lastName: status,
                                  firstName: init.firstName
                                };
                        }));
                  if (result$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$2,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurFirstNameField */3 :
                  var result$3 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.firstName, validators_firstName, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  useOfPorter: init.useOfPorter,
                                  city: init.city,
                                  lastName: init.lastName,
                                  firstName: status
                                };
                        }));
                  if (result$3 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$3,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* Submit */4 :
                  var match = state.formStatus;
                  if (typeof match !== "number" && match.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  var match$1 = validateForm(state.input, validators, state.fieldsStatuses, metadata);
                  if (match$1.TAG !== /* Valid */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: match$1.fieldsStatuses,
                              collectionsStatuses: match$1.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: /* AttemptedToSubmit */1
                            }
                          };
                  }
                  var output = match$1.output;
                  var error = state.formStatus;
                  var tmp;
                  tmp = typeof error === "number" || error.TAG !== /* SubmissionFailed */1 ? undefined : Caml_option.some(error._0);
                  return {
                          TAG: /* UpdateWithSideEffects */1,
                          _0: {
                            input: state.input,
                            fieldsStatuses: match$1.fieldsStatuses,
                            collectionsStatuses: match$1.collectionsStatuses,
                            formStatus: {
                              TAG: /* Submitting */0,
                              _0: tmp
                            },
                            submissionStatus: /* AttemptedToSubmit */1
                          },
                          _1: (function (param) {
                              var dispatch = param.dispatch;
                              return Curry._2(onSubmit, output, {
                                          notifyOnSuccess: (function (input) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmittedStatus */4,
                                                          _0: input
                                                        });
                                            }),
                                          notifyOnFailure: (function (error) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmissionFailedStatus */5,
                                                          _0: error
                                                        });
                                            }),
                                          reset: (function (param) {
                                              return Curry._1(dispatch, /* Reset */7);
                                            }),
                                          dismissSubmissionResult: (function (param) {
                                              return Curry._1(dispatch, /* DismissSubmissionResult */6);
                                            })
                                        });
                            })
                        };
                  break;
              case /* DismissSubmissionError */5 :
                  var match$2 = state.formStatus;
                  if (typeof match$2 === "number" || match$2.TAG !== /* SubmissionFailed */1) {
                    return /* NoUpdate */0;
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* DismissSubmissionResult */6 :
                  var match$3 = state.formStatus;
                  if (typeof match$3 === "number") {
                    if (match$3 === /* Editing */0) {
                      return /* NoUpdate */0;
                    }
                    
                  } else if (match$3.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: /* Editing */0,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* Reset */7 :
                  return {
                          TAG: /* Update */0,
                          _0: initialState(initialInput)
                        };
              
            }
          } else {
            switch (action.TAG | 0) {
              case /* UpdateUseOfPorterField */0 :
                  var nextInput = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput, metadata, state.fieldsStatuses.useOfPorter, state.submissionStatus, validators_useOfPorter, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            useOfPorter: status,
                                            city: init.city,
                                            lastName: init.lastName,
                                            firstName: init.firstName
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateCityField */1 :
                  var nextInput$1 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$1,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$1, metadata, state.fieldsStatuses.city, state.submissionStatus, validators_city, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            useOfPorter: init.useOfPorter,
                                            city: status,
                                            lastName: init.lastName,
                                            firstName: init.firstName
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateLastNameField */2 :
                  var nextInput$2 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$2,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$2, metadata, state.fieldsStatuses.lastName, state.submissionStatus, validators_lastName, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            useOfPorter: init.useOfPorter,
                                            city: init.city,
                                            lastName: status,
                                            firstName: init.firstName
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateFirstNameField */3 :
                  var nextInput$3 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$3,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$3, metadata, state.fieldsStatuses.firstName, state.submissionStatus, validators_firstName, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            useOfPorter: init.useOfPorter,
                                            city: init.city,
                                            lastName: init.lastName,
                                            firstName: status
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* SetSubmittedStatus */4 :
                  var input = action._0;
                  if (input !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: input,
                              fieldsStatuses: {
                                useOfPorter: /* Pristine */0,
                                city: /* Pristine */0,
                                lastName: /* Pristine */0,
                                firstName: /* Pristine */0
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: {
                                useOfPorter: /* Pristine */0,
                                city: /* Pristine */0,
                                lastName: /* Pristine */0,
                                firstName: /* Pristine */0
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* SetSubmissionFailedStatus */5 :
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: {
                              TAG: /* SubmissionFailed */1,
                              _0: action._0
                            },
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* MapSubmissionError */6 :
                  var map = action._0;
                  var error$1 = state.formStatus;
                  if (typeof error$1 === "number") {
                    return /* NoUpdate */0;
                  }
                  if (error$1.TAG !== /* Submitting */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* SubmissionFailed */1,
                                _0: Curry._1(map, error$1._0)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
                  var error$2 = error$1._0;
                  if (error$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* Submitting */0,
                                _0: Caml_option.some(Curry._1(map, Caml_option.valFromOption(error$2)))
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              
            }
          }
        }));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = state.formStatus;
  var tmp;
  tmp = typeof match$1 === "number" || match$1.TAG !== /* Submitting */0 ? false : true;
  return {
          updateUseOfPorter: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateUseOfPorterField */0,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateCity: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateCityField */1,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateLastName: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateLastNameField */2,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateFirstName: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateFirstNameField */3,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          blurUseOfPorter: (function (param) {
              return Curry._1(dispatch, /* BlurUseOfPorterField */0);
            }),
          blurCity: (function (param) {
              return Curry._1(dispatch, /* BlurCityField */1);
            }),
          blurLastName: (function (param) {
              return Curry._1(dispatch, /* BlurLastNameField */2);
            }),
          blurFirstName: (function (param) {
              return Curry._1(dispatch, /* BlurFirstNameField */3);
            }),
          useOfPorterResult: Formality.exposeFieldResult(state.fieldsStatuses.useOfPorter),
          cityResult: Formality.exposeFieldResult(state.fieldsStatuses.city),
          lastNameResult: Formality.exposeFieldResult(state.fieldsStatuses.lastName),
          firstNameResult: Formality.exposeFieldResult(state.fieldsStatuses.firstName),
          input: state.input,
          status: state.formStatus,
          dirty: (function (param) {
              var match = state.fieldsStatuses;
              if (match.useOfPorter || match.city || match.lastName || match.firstName) {
                return true;
              } else {
                return false;
              }
            }),
          valid: (function (param) {
              var match = validateForm(state.input, validators, state.fieldsStatuses, metadata);
              if (match.TAG === /* Valid */0) {
                return true;
              } else {
                return false;
              }
            }),
          submitting: tmp,
          submit: (function (param) {
              return Curry._1(dispatch, /* Submit */4);
            }),
          dismissSubmissionError: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionError */5);
            }),
          dismissSubmissionResult: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionResult */6);
            }),
          mapSubmissionError: (function (map) {
              return Curry._1(dispatch, {
                          TAG: /* MapSubmissionError */6,
                          _0: map
                        });
            }),
          reset: (function (param) {
              return Curry._1(dispatch, /* Reset */7);
            })
        };
}

var Form = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

export {
  Form ,
  
}
/* react Not a pure module */
